import React from "react";
import MDEditor, { commands } from "@uiw/react-md-editor";
import "@uiw/react-md-editor/markdown-editor.css";

type MarkdownCellProps = {
  id: string;
  value: string;
  editing: boolean;
  readOnly?: boolean;
  onFocus: () => void;
  onChange: (next: string) => void;
  isDarkMode?: boolean;
};

const MarkdownCell: React.FC<MarkdownCellProps> = ({
  value,
  editing,
  readOnly,
  onFocus,
  onChange,
  isDarkMode = false,
}) => {
  if (editing) {
    return (
      <div onClick={onFocus} className="w-full markdown-editor-custom">
        <style>{`
          .markdown-editor-custom .w-md-editor-toolbar {
            padding: 8px 10px;
            gap: 4px;
          }
          .markdown-editor-custom .w-md-editor-toolbar button {
            width: 22px;
            height: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 2px;
          }
          .markdown-editor-custom .w-md-editor-toolbar svg {
            width: 22px;
            height: 22px;
          }
          .markdown-editor-custom .w-md-editor-toolbar-divider {
            margin: 0 8px;
          }
        `}</style>
        <MDEditor
          value={value}
          onChange={(val) => onChange(val || "")}
          preview="edit"
          hideToolbar={false}
          height={Math.max(200, value.split("\n").length * 20 + 60)}
          visibleDragbar={false}
          textareaProps={{
            readOnly: !!readOnly,
          }}
          style={{
            fontSize: "14px",
          }}
          data-color-mode={isDarkMode ? "dark" : "light"}
          commands={[
            commands.bold,
            commands.italic,
            commands.strikethrough,
            commands.divider,
            commands.title,
            commands.divider,
            commands.link,
            commands.quote,
            commands.code,
            commands.image,
            commands.divider,
            commands.unorderedListCommand,
            commands.orderedListCommand,
            commands.checkedListCommand,
          ]}
          extraCommands={[
            commands.codeEdit,
            commands.codeLive,
            commands.codePreview,
          ]}
        />
      </div>
    );
  }

  return (
    <div
      onClick={onFocus}
      className="w-full rounded p-2 cursor-text bg-white dark:bg-[#0d1117]"
      data-color-mode={isDarkMode ? "dark" : "light"}
    >
      <MDEditor.Markdown
        source={value || "*Click to edit*"}
        style={{ whiteSpace: "pre-wrap", fontSize: "14px", backgroundColor: "transparent" }}
      />
    </div>
  );
};

export default MarkdownCell;
